/**
 * Typed page state and response mapping for the Buildings listing.
 *
 * Canonical source of truth for all Buildings/Index adapter/hook/service files.
 * Shared listing primitives come from @hooks/listings — only Buildings-specific
 * types are defined here.
 */
// ---------------------------------------------------------------------------
// Initial / default filter values
// ---------------------------------------------------------------------------
export const INITIAL_BUILDING_FILTERS = {
    account: [],
    tags: [],
    territory: [],
    additionalTerritory: [],
    salesPerson: [],
    compliancePlatform: [],
    status: true,
    name: '',
    externalId: ''
};
/**
 * Filter keys active by default.
 * Mirrors INITIAL_FILTERS.active from constants.js (omits compliancePlatform + territorySubtype).
 * Account is included here; it is dropped from the embed default set by the config hook (task-04).
 */
export const DEFAULT_ACTIVE_FILTER_KEYS = [
    'account',
    'status',
    'tags',
    'name',
    'externalId',
    'territory',
    'additionalTerritory',
    'salesPerson'
];
// ---------------------------------------------------------------------------
// Non-sortable column keys (IP-15590)
// ---------------------------------------------------------------------------
/** Frontend marks these as `sortable: false`; persisted sorts on them must be dropped. */
export const NON_SORTABLE_COLUMN_KEYS = new Set(['siteId', 'inspectionsCount']);
